import { render, staticRenderFns } from "./AssignUserClasse.vue?vue&type=template&id=3eb79f35&scoped=true"
import script from "./AssignUserClasse.vue?vue&type=script&lang=js"
export * from "./AssignUserClasse.vue?vue&type=script&lang=js"
import style0 from "./AssignUserClasse.vue?vue&type=style&index=0&id=3eb79f35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb79f35",
  null
  
)

export default component.exports